import { render } from "./Notification.vue?vue&type=template&id=8562455c&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=8562455c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8562455c"

export default script